import React, { useEffect, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { Link, useNavigate } from 'react-router-dom';
import { GAMEUPDATESCORE, DAILYTARGET, GAME, BMIINFOAVERAGE, BUDDYGAMEJOIN, BMIPROGRESSION, BUDDYTOURNAMENTJOIN, CREATE_GAME_SESSION, GETMONTHLYLEADERBOARD, CLOSE_SESSION, AVATAR_IMAGE_URL, REAL_BADGE, PIGGYBANK, GET_SETTINGS_DATA } from '../helpers/Constant';
import { getUserType, getUserInfo, getUserStreak, checkAuth, formatCompactNumber } from '../utils/common';
import { getDataWithToken, postDataWithToken } from '../api/api';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import Bottombar from '../common/bottombar';
import moment from 'moment';
import BackButton from '../common/backButton';
import InfoModal from '../common/InfoModal';
import SessionHistory from '../common/SessionHistory';
import MonthlyLeaderBoard from '../common/monthlyLeaderBoard';
import StreakSaver from './Home/StreakSaver';
import UserRetention from './Home/userRetention';
import StreakView from './Home/StreakView';
import DailyTarget from './Home/DailyTarget';

function Home() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(getUserInfo());
    const userType = getUserType();
    const [dailyBurned, setDailyBurned] = useState(0);
    const [loading, setLoading] = useState(true);

    const [currentPoint, setCurrentPointData] = useState(0);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [modalName, setModalName] = useState('');
    const [monthlyLeaderboardData, setMonthlyLeaderboardData] = useState([]);
    const [monthlyUserPosition, setMonthlyUserPosition] = useState(0);
    const [daysUntilMonthEnd, setDaysUntilMonthEnd] = useState(0);
    const [ShowSessionModal, setShowSessionModal] = useState(false);
    const [sessionId, setSessionId] = useState('');
    const [piggyBankLimit, setPiggyBankLimit] = useState(500);
    const [piggyCoins, setPiggyCoins] = useState(0);
    const [showStreakInfoModal, setShowStreakInfoModal] = useState(false);
    const [showPointsInfoModal, setShowPointsInfoModal] = useState(false);
    const [sessionHistoryClosedSignal, setSessionHistoryClosedSignal] = useState(0);
    const [streakModalSignal, setStreakModalSignal] = useState(true);
    const currentMonth = moment().month() + 1;

    const ModalContent = {
        "League": {
            title: t('How League works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "BuddyTournament": {
            title: t('How Buddy Tournament Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "LeagueTier": {
            title: t('How League Tier') + ' ' + t('Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "VersusGames": {
            title: t('How Versus Games Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "PaidTournament": {
            title: t('How Paid Tournament Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "FreeTournament": {
            title: t('How Free Tournament Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "AchivementsBadges": {
            title: t('How Achievements Badges Works?'),
            message: 'The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incididunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
        },
        "MonthlyLeaderboard": {
            title: t('How Monthly Leaderboard Works?'),
            message: 'The Monthly Leaderboard tracks your points and calories burned throughout the current month. Compete with other players and see your rank in real-time. The leaderboard resets automatically on the 1st of each month, giving everyone a fresh start.'
        }
    }

    const fetchSettingsData = async () => {
        const response = await getDataWithToken(GET_SETTINGS_DATA);
        if (response) {
            if (response.piggy_bank_limit) {
                setPiggyBankLimit(parseInt(response.piggy_bank_limit));
            }
        }
    }

    const fetchMonthlyLeaderboard = async () => {
        try {
            const limit = 10;
            const monthlyLeaderboard = await getDataWithToken( `${GETMONTHLYLEADERBOARD}?limit=${limit}}`);
            if (monthlyLeaderboard) {
                const users = monthlyLeaderboard.users || [];
                
                if (users.length > 0) {;
                    setMonthlyLeaderboardData(users);
                    setMonthlyUserPosition(monthlyLeaderboard.currentUserRank || 0);
                } else {
                    setMonthlyLeaderboardData([]);
                    setMonthlyUserPosition(0);
                }
            } else {
                setMonthlyLeaderboardData([]);
                setMonthlyUserPosition(0);
            }
        } catch (error) {
            setMonthlyLeaderboardData([]);
            setMonthlyUserPosition(0);
        }
    }

    const fetchData = async () => {
        try {
            setLoading(true);

            if (userData?.userAccount?.piggyBankAmount) {
                setPiggyCoins(parseInt(userData.userAccount.piggyBankAmount));
            }
            if (userData?.currentPoint) {
                setCurrentPointData(userData.currentPoint);
            }

            const bmiInfoData = await postDataWithToken(BMIINFOAVERAGE);
            if (bmiInfoData.data && bmiInfoData.data.length > 0) {
                setDailyBurned(bmiInfoData.data[0].burned);
            }

            fetchMonthlyLeaderboard();
        } catch (error) { } finally {
            setLoading(false);
        }
    };

    const calculateDaysUntilMonthEnd = () => {
        const now = moment();
        const endOfMonth = moment().endOf('month');
        const daysRemaining = endOfMonth.diff(now, 'days');
        return daysRemaining;
    };

    const refreshUserData = async () => {
        const latestUserData = await checkAuth();
        if (latestUserData) {
            setUserData(latestUserData);
            if (latestUserData?.userAccount?.piggyBankAmount) {
                setPiggyCoins(parseInt(latestUserData.userAccount.piggyBankAmount));
            }
            if (latestUserData?.currentPoint) {
                setCurrentPointData(latestUserData.currentPoint);
            }
        }
    };

    useEffect(() => {
        const userType = getUserType();
        if (userType && userType !== 'guest_user') {
            fetchData();
            fetchSettingsData();    
        } else {
            setLoading(false);
        }

        setDaysUntilMonthEnd(calculateDaysUntilMonthEnd());

        const intervalDays = setInterval(() => {
            setDaysUntilMonthEnd(calculateDaysUntilMonthEnd());
        }, 3600000); // Every hour

        return () => {
            // clearInterval(intervalTime);
            clearInterval(intervalDays);
        };
    }, []);

    useEffect(() => {
        const referralData = JSON.parse(localStorage.getItem('referralData'));

        if (referralData) {
            const { roomCode } = referralData;
            
            const joinBuddyGame = async () => {
                try {
                    setLoading(true);
                    const gameJoinData = {
                        "fname": userData?.fname || '',
                        "lname": userData?.lname || '',
                        "code": roomCode,
                        "user": userData?._id || '',
                    };

                    const response = await postDataWithToken(BUDDYGAMEJOIN, gameJoinData);
                    
                    if (response.status === 200) {
                        localStorage.setItem('joinGameId', response.data._id);
                        localStorage.setItem('joinPlayerId', response.data.currentPlayId);
                        localStorage.setItem('playerName', response.data.newUser.name);
                        localStorage.removeItem('referralData');
                        navigate(`/${BUDDYTOURNAMENTJOIN}`);
                    } else {
                        localStorage.removeItem('referralData');
                    }
                } catch (error) {
                    localStorage.removeItem('referralData');
                } finally {
                    setLoading(false);
                }
            };

            joinBuddyGame();
        }
    }, [navigate, userData]);
    
    function getPositionSuffix(position) {
        const suffixes = ['st', 'nd', 'rd'];
        const remainder = position % 10;

        if (position === 11 || position === 12 || position === 13) {
            return `${position}th`;
        }

        return `${position}${suffixes[remainder - 1] || 'th'}`;
    }

    function calculateInitialTime() {
        const now = new Date();
        const seconds = now.getSeconds();
        const minutes = now.getMinutes();

        const nextHalfHour = minutes < 30 ? 30 : 60;
        const minutesUntilNextHalfHour = nextHalfHour - minutes - 1;
        const secondsUntilNextHalfHour = (minutesUntilNextHalfHour * 60) + (60 - seconds);
        return secondsUntilNextHalfHour;
    }

    const handleGoBurn = async () => {
        setLoading(true);
        try {
            const response = await postDataWithToken(CREATE_GAME_SESSION, {});
            if (response.status === 200 && response.data) {
                const utcDateTime = new Date().toISOString();
                const dailyTarget = (userData != null && userData.dailyTarget) ? userData.dailyTarget : 1000;
                const currentDailyTarget = Math.round(dailyTarget);
                
                const url = `uniwebview://openGame?sessionId=${response.data.sessionId}&date=${encodeURIComponent(utcDateTime)}&dailyBurned=${dailyBurned}&dailyTarget=${currentDailyTarget}&isPrimeUser=${userData && userData.userAccount.isPrimeUser}`;
                window.location.href = url;
            }
        } catch (error) {} 
        finally {
            setLoading(false);
        }
    }

    window.onGameClosed = async function (calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak=1, piggyCoin=0) {
        handleGameClosed(calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak, piggyCoin);
    };

    const handleGameClosed = async (calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak, piggyCoin) => {
        try {
            const userResult = {
                "score": score,
                "burnedCal": calories,
                "accuracy" : accuracy,
                "time" : time,
                "heartbeat" : heartbeat,
                "sessionId" : sessionId,
                "gameName" : gameName,
                "piggyStreak" : piggyStreak,
                "piggyCoin" : piggyCoin
            }
            const response = await postDataWithToken(GAMEUPDATESCORE, userResult);

            if (response.status === 200) {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    window.onSessionCompleted = async function (sessionId) {
        setSessionId(sessionId);

        await postDataWithToken(`${CLOSE_SESSION}${sessionId}`);

        await refreshUserData();

        await fetchData();

        setShowSessionModal(true);
    }

    const handleCloseSessionHistoryModal = () => {
        setShowSessionModal(false);
        if (!userData?.userAccount?.isRetentionFlowCompleted && !userData?.userAccount?.isPrimeUser) {
            setSessionHistoryClosedSignal((prev) => prev + 1);
        }
    }

    const dailyTarget = (userData != null && userData.dailyTarget) ? userData.dailyTarget : 1000;
    const dailyTargetPercentage = Math.min(Math.round((dailyBurned / dailyTarget) * 100), 100);

    const goToPiggyBank = () => {
        navigate(`/${PIGGYBANK}`);
    }

    return (
        <div className='wrapper h-100'>

            {loading ?
                <div className="loader">
                    <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
                </div>
                : ""}
            {(ShowSessionModal) && <BackButton label={t('Back')} closeFunction={handleCloseSessionHistoryModal} />}
            {(showInfoModal) && <BackButton label={t('Back')} closeFunction={() => setShowInfoModal(false)} />}
            {(showStreakInfoModal) && <BackButton label={t('Back')} closeFunction={() => setShowStreakInfoModal(false)} />}
            {(showPointsInfoModal) && <BackButton label={t('Back')} closeFunction={() => setShowPointsInfoModal(false)} />}

            <div className='home_wrapper'>
                {/* Profile */}
                <div className='profile_wrapper pb-3'>
                    <div className='row align-items-center justify-content-between flex-nowrap g-0'>
                        <div className='col-auto flex-fill'>
                            <div className='row gx-3 align-items-center flex-nowrap'>
                                <div className='col-auto'>
                                    {userData && userData.avtar ?
                                        <div className='rounded-circle profile_img user_profile border border-white d-flex justify-content-center align-items-center avtar_alternate overflow-hidden'>
                                            <img src={AVATAR_IMAGE_URL + userData._id + "/" + userData.avtar} alt='Profile' className='img-fluid' />
                                        </div>
                                        :
                                        <div className='rounded-circle profile_img user_profile border border-white d-flex justify-content-center align-items-center avtar_alternate'>
                                            <h6 className='mb-0 text-white fw-bold text-uppercase'>{userData && userData.fname && userData.lname ? userData.fname[0] + userData.lname[0] : 'G'}</h6>
                                        </div>
                                    }
                                </div>
                                <div className='col-auto ps-1'>
                                    <h5 className='mb-0 text-white'>{t('Hello...')}</h5>
                                    <h4 className='mb-0 text-white fw-bold pe-3'>{userType === 'real_user' && userData != null ? userData.fname + ' ' + userData.lname : t('Guest')}</h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-auto d-flex align-items-center gap-3'>
                            <div className='streak_saver_info_icon d-flex align-items-center gap-1' onClick={() => setShowStreakInfoModal(true)}>
                                <img src='../images/streak-saver.png' alt='Streak Saver' className='img-fluid streak_saver_icon' />
                                <p className='mb-0 mx-auto text-white fw-bold lh-1'>{userData.userStreaks?.streakSavers || 0}</p>
                            </div>
                            <div className='reward_price d-flex align-items-center gap-1' role='button' onClick={() => setShowPointsInfoModal(true)}>
                                <span className='d-flex align-items-center justify-content-center fw-bold point_icon'></span>
                                <p className='mb-0 mx-auto text-white fw-bold'>{formatCompactNumber(currentPoint)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={userType === 'guest_user' ? 'blury_block' : ''}>
                    {/* Daily Target */}
                    <DailyTarget userData={userData} dailyTarget={dailyTarget} dailyBurned={dailyBurned} dailyTargetPercentage={dailyTargetPercentage} />

                    {/* Streak */}
                    <StreakView userStreaks={userData?.userStreaks} />

                    {/* Real Badge Achievement */}
                    <div className='real_badge_wrapper position-relative'>
                        <Link to={`/${REAL_BADGE}`} className='text-decoration-none'>
                            <div className='real_badge d-flex justify-content-between position-relative'>
                                <div className='real_badge_content'>
                                    <div className='real_badge_sub_title fw-bold mb-1'>Real Badge Achievement</div>
                                    <div className='real_badge_heading'>
                                        <span className='real_badge_count fw-bold text-white'>{currentMonth}/12</span>
                                        <h5 className='real_badge_title fw-bold'>{currentMonth <= 3 ? 'Tri-Month Titan' : currentMonth <= 6 ? 'Six-Month Titan' : 'Twelve-Month Titan'}</h5>
                                    </div>
                                </div>
                                <div className='real_badge_image position-relative'>
                                    <img src={`../images/${currentMonth <= 3 ? 'three-month.png' : currentMonth <= 6 ? 'six-month.png' : 'twelve-month.png'}`} alt="Titan" className='position-relative z-1' />
                                    <div className='real_badge_image_shadow bg-white rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                                </div>
                            </div>
                        </Link>
                    </div>

                    {/* Monthly Leaderboard */}
                    <MonthlyLeaderBoard monthlyLeaderboardData={monthlyLeaderboardData} userData={userData} handleGoBurn={handleGoBurn} daysUntilMonthEnd={daysUntilMonthEnd} monthlyUserPosition={monthlyUserPosition} onInfoClick={() => { setShowInfoModal(true); setModalName('MonthlyLeaderboard'); }} />

                    {/* Piggy bank */}
                    <div className='piggy_bank_wrapper bg-primary rounded-corners p-12 mt-3'>
                        <div onClick={goToPiggyBank} className='text-decoration-none'>
                            <div className='piggy_bank d-flex justify-content-between gap-2 mb-1'>
                                <div className='piggy_bank_left'>
                                    <h4 className='text-white fw-bold opacity-75'>Piggy Bank</h4>
                                    <div className='piggy_bank_count fw-bold'>
                                        <span className='text-warning'>{piggyCoins}</span>
                                        <span className='text-white opacity-75'>/{piggyBankLimit}</span>
                                    </div>
                                </div>
                                <div className='piggy_bank_right d-flex align-items-end'>
                                    <div className='piggy_bank_percentage text-warning fw-bold mb-2'>{isNaN(piggyCoins / piggyBankLimit * 100) ? 0 : Math.round(piggyCoins / piggyBankLimit * 100)}%</div>
                                    <div className='piggy_bank_image position-relative'>
                                        <img src="../images/piggy-bank.png" alt="piggy-bank" className='piggy_bank_image_outer opacity-25' />
                                        <img src="../images/piggy-bank.png" alt="piggy-bank" className='piggy_bank_image_fill position-absolute bottom-0 start-0 w-100' style={{ maxHeight: `${isNaN(piggyCoins / piggyBankLimit * 100) ? 0 : Math.round(piggyCoins / piggyBankLimit * 100)}%` }} />
                                    </div>
                                </div>
                            </div>
                            <div className='progressbar_track position-relative bg-light w-100'>
                                <div className='progressbar_thumb position-absolute start-0 top-0 bottom-0 bg-warning mw-100 rounded-1' style={{ width: `${isNaN(piggyCoins / piggyBankLimit * 100) ? 0 : Math.round(piggyCoins / piggyBankLimit * 100)}%` }}></div>
                            </div>
                        </div>
                    </div>

                    {/* League */}
                    <div className='league_wrapper bg-primary rounded-corners p-12 mt-3 position-relative'>
                        <div className='league d-flex justify-content-between gap-2'>
                            <div className='league_left'>
                                <h3 className='league_title text-white fw-bold opacity-75 mb-1'>{t('League')} <BiInfoCircle className='text-light' onClick={() => { setShowInfoModal(true); setModalName('League');}} /></h3>
                                <p className='league_text text-white fw-medium opacity-25 mb-0'>Go challenge other player and same time burn your calories in competitive game</p>
                            </div>
                            <div className='league_right position-relative'>
                                <div className='coming_soon position-absolute z-1 d-flex align-items-center justify-content-center text-white'>Coming soon</div>
                                <div className='league_price text-warning fw-bold text-center position-relative'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10.461" height="10.38" viewBox="0 0 10.461 10.38" className="position-absolute top-0 start-100 translate-middle">
                                        <g transform="translate(1.414 8.966) rotate(-90)">
                                            <path d="M0,0,7.552,7.633" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                            <path d="M0,7.633H7.552V0" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                        </g>
                                    </svg>
                                    <span className='d-block'>$40</span>Entry
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Fitness Racing */}
                    <div className='fitness_racing_wrapper bg-warning rounded-corners p-12 ps-1 mt-3 position-relative'>
                        <div className='fitness_racing d-flex justify-content-between gap-2'>
                            <div className='fitness_racing_left'>
                                <img src="../images/fitness-racing.jpg" alt="Fitness Racing" />
                            </div>
                            <div className='fitness_racing_right position-relative'>
                                <div className='coming_soon position-absolute z-1 d-flex align-items-center justify-content-center'>Coming soon</div>
                                <div className='fitness_racing_price fw-bold text-center position-relative'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10.461" height="10.38" viewBox="0 0 10.461 10.38" className="position-absolute top-0 start-100 translate-middle">
                                        <g transform="translate(1.414 8.966) rotate(-90)">
                                            <path d="M0,0,7.552,7.633" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                            <path d="M0,7.633H7.552V0" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                        </g>
                                    </svg>
                                    <span className='d-block'>$20</span>Entry
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Buddy Tournament */}
                    <div className='league_wrapper bg-primary rounded-corners p-12 mt-3 mb-4 position-relative'>
                        <div className='league d-flex justify-content-between gap-2'>
                            <div className='league_left'>
                                <h3 className='league_title text-white fw-bold opacity-75 mb-1'>{t('Buddy Tournament')} <BiInfoCircle className='text-light' onClick={() => { setShowInfoModal(true); setModalName('BuddyTournament');}} /></h3>
                                <p className='league_text text-white fw-medium opacity-25 mb-0'>Go challenge other player and same time burn your calories in competitive game</p>
                            </div>
                            <div className='league_right position-relative'>
                                <div className='coming_soon position-absolute z-1 d-flex align-items-center justify-content-center text-white'>Coming soon</div>
                                <div className='league_price text-warning fw-bold text-center position-relative'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10.461" height="10.38" viewBox="0 0 10.461 10.38" className="position-absolute top-0 start-100 translate-middle">
                                        <g transform="translate(1.414 8.966) rotate(-90)">
                                            <path d="M0,0,7.552,7.633" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                            <path d="M0,7.633H7.552V0" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {ShowSessionModal && sessionId !== '' ? <SessionHistory showSessionHistoryModal={ShowSessionModal} sessionId={sessionId} closeSessionHistoryModal={handleCloseSessionHistoryModal} dailyBurned={dailyBurned} dailyTarget={dailyTarget} dailyTargetPercentage={dailyTargetPercentage} showRetentionData={true} /> : ''}

            <InfoModal modalContent={ModalContent[modalName]} showInfoModal={showInfoModal} />

            <div className={`streak_saver_info_modal modal ${showPointsInfoModal ? 'show' : ''}`} style={{ display: showPointsInfoModal ? 'block' : 'none' }}>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div className='modal-content modal_content streak_saver_modal'>
                        <div className='modal-body p-0 text-center'>
                            <img className='streak_saver_image' src='../images/active-coin.png' alt='Points' width={175} />
                            <h2 className='streak_saver_title fw-bold text-uppercase px-2'>{currentPoint}</h2>
                            <div className='streak_saver_status fw-light text-capitalize px-2'>{t('Earn more by staying active')}</div>
                            <div className='streak_saver_description fw-medium text-white py-3 px-2'>
                                <ul className='list-unstyled my-1'>
                                    <li>{t('Points are earned when you burn calories and complete daily targets.')}</li>
                                    <li>{t('Use points to climb the monthly leaderboard.')}</li>
                                    <li>{t('Keep playing games and hitting goals to earn more.')}</li>
                                </ul>
                            </div>
                            <div className='streak_saver_feedback fw-light px-2'>{t('You currently have')} {currentPoint} {t('point(s).')}</div>
                            <div className='streak_saver_buttons d-flex flex-column align-items-center py-3 px-2'>
                                <button className='cta_button bg-warning border-0 text-uppercase' onClick={() => setShowPointsInfoModal(false)}>{t('Ok')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showPointsInfoModal && <div className="modal-backdrop show"></div>}

            <StreakSaver user={userData} onUserRefresh={refreshUserData} showStreakInfoModal={showStreakInfoModal} closeStreakInfoModal={() => setShowStreakInfoModal(false)} streakModalSignals={setStreakModalSignal} />

            {!userData?.userAccount?.isRetentionFlowCompleted && !userData?.userAccount?.isPrimeUser && (
                <UserRetention userData={userData} piggyBankLimit={piggyBankLimit} sessionHistoryClosedSignal={sessionHistoryClosedSignal} streakModalClosedSignal={streakModalSignal} onUserRefresh={refreshUserData} />
            )}

            <Bottombar />
        </div>
    );
}

export default Home;